module.exports = ".projects, my-footer {\n  animation: fadein 1s; }\n\n.project {\n  cursor: pointer;\n  margin-bottom: 4rem; }\n\nimg {\n  min-height: 112px;\n  margin-bottom: 0.5rem;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.6); }\n\nh1 {\n  cursor: pointer; }\n  h1:focus {\n    outline: 0; }\n\nh2 {\n  font-size: 1.25rem;\n  margin-bottom: 0.25rem; }\n\nh3 {\n  color: #636c72;\n  font-size: 1rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/art/art.component.scss
// module id = 198
// module chunks = 1